var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
// Redux
import * as redux from "redux";
import { connect } from "react-redux";
import * as Actions from "products/widgets/actions";
import IFrameView from "products/widgets/ui/IFrameView";
import { Loading } from "common/ui/loading/Loading";
const mapStateToProps = (state, props) => ({
    widget: state.products.widgets
});
const mapDispatchToProps = (dispatch) => ({
    actions: redux.bindActionCreators(Actions, dispatch),
    dispatch: dispatch
});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let SpotlightProductsView = class SpotlightProductsView extends React.Component {
    componentDidMount() {
        this.props.actions.getSpotlightListingWidgetUrl(this.props.params.officeId);
    }
    componentWillUnmount() {
        this.props.actions.createAction_SetSpotlightListing(null);
    }
    render() {
        let { widget } = this.props;
        if (!widget || !widget.spotlightListingUrl) {
            return React.createElement(Loading, null);
        }
        return (React.createElement(IFrameView, { url: widget.spotlightListingUrl }));
    }
};
SpotlightProductsView = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], SpotlightProductsView);
export default SpotlightProductsView;
